export default "<div class=\"animated fadeIn\">\n    <span>AZP</span>\n</div>";